import { formatPrice } from 'features/home/components/HomeSubscription/utils'
import IntlFormattedDate from 'app/i18n/IntlFormattedDate'
import {
  PurchaseSubscritpionTotalBlock,
  PurchaseSubscritpionBlockItem,
  PurchaseSubscritpionNetworkTotalLabel,
  PurchaseSubscritpionItemTitle,
  PurchaseSubscritpionItemSubTitle,
  PurchaseSubscritpionTotalTitle,
  PurchaseSubscritpionItemCount,
  PurchaseSubscritpionItemSum,
  BottomLine,
  BilledAnnualWrapper,
  BilledAnnualLabel,
  TaxTotalCostTitle,
  PurchaseSubscritpionPointsSum,
} from './styles'
import { useIntl } from 'react-intl'
import { subscriptionManagementMessages } from 'features/home/components/HomeSubscription/SubscriptionManagement/messages'

export interface PurchaseDeviceTotalProps {
  apQuantity: number
  apPrice: number
  essentialsPrice: number
  totalPrice: number
  renewalDate: number
  subscriptionState: string
  renewingStatus: number[]
  essentialsCredits: number
  apCredits: number
}

const PurchaseDeviceTotal = (props: PurchaseDeviceTotalProps) => {
  const {
    apQuantity,
    apPrice,
    essentialsPrice,
    totalPrice,
    renewalDate,
    subscriptionState,
    renewingStatus,
    essentialsCredits,
    apCredits,
  } = props
  const { formatMessage } = useIntl()

  return (
    <PurchaseSubscritpionTotalBlock>
      <PurchaseSubscritpionBlockItem>
        <PurchaseSubscritpionNetworkTotalLabel>
          Home Subscription Details
        </PurchaseSubscritpionNetworkTotalLabel>
      </PurchaseSubscritpionBlockItem>

      {subscriptionState === 'ENROLLED' && renewingStatus[1] === 1 && (
        <PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionItemTitle>
            Savant Essentials
          </PurchaseSubscritpionItemTitle>
          <PurchaseSubscritpionPointsSum>
            {formatPrice(essentialsPrice)}
          </PurchaseSubscritpionPointsSum>
        </PurchaseSubscritpionBlockItem>
      )}

      {subscriptionState === 'ENROLLED' && (
        <PurchaseSubscritpionBlockItem>
          <div>
            <PurchaseSubscritpionItemTitle>
              Access Points
            </PurchaseSubscritpionItemTitle>
            <PurchaseSubscritpionItemCount>
              x {subscriptionState === 'ENROLLED' ? apQuantity : 0}
            </PurchaseSubscritpionItemCount>
          </div>
          <PurchaseSubscritpionPointsSum>
            {formatPrice(
              subscriptionState === 'ENROLLED' ? apPrice * apQuantity : 0
            )}
          </PurchaseSubscritpionPointsSum>
        </PurchaseSubscritpionBlockItem>
      )}
      <BottomLine />

      <PurchaseSubscritpionBlockItem>
        <PurchaseSubscritpionTotalTitle>
          Total Price
        </PurchaseSubscritpionTotalTitle>
        <PurchaseSubscritpionItemSum>
          {formatPrice(subscriptionState !== 'WILL_NOT_RENEW' ? totalPrice : 0)}
        </PurchaseSubscritpionItemSum>
      </PurchaseSubscritpionBlockItem>
      <BilledAnnualWrapper>
        <BilledAnnualLabel>Billed Annually</BilledAnnualLabel>
      </BilledAnnualWrapper>

      {essentialsCredits > 0 && (
        <>
          <BottomLine />
          <PurchaseSubscritpionBlockItem>
            <PurchaseSubscritpionItemSubTitle>
              Savant Essentials Credit
            </PurchaseSubscritpionItemSubTitle>
            <PurchaseSubscritpionPointsSum>
              {formatPrice(essentialsCredits)}
            </PurchaseSubscritpionPointsSum>
          </PurchaseSubscritpionBlockItem>
        </>
      )}

      {apCredits > 0 && (
        <PurchaseSubscritpionBlockItem>
          <PurchaseSubscritpionItemSubTitle>
            Access Points Credit
          </PurchaseSubscritpionItemSubTitle>
          <PurchaseSubscritpionPointsSum>
            {formatPrice(apCredits)}
          </PurchaseSubscritpionPointsSum>
        </PurchaseSubscritpionBlockItem>
      )}

      <BottomLine />
      <PurchaseSubscritpionBlockItem>
        <PurchaseSubscritpionItemSubTitle>
          {subscriptionState !== 'WILL_NOT_RENEW'
            ? 'Renewal Date'
            : 'Expiration Date'}
        </PurchaseSubscritpionItemSubTitle>
        <PurchaseSubscritpionItemSubTitle>
          <IntlFormattedDate date={renewalDate} />
        </PurchaseSubscritpionItemSubTitle>
      </PurchaseSubscritpionBlockItem>
      <BottomLine />

      <PurchaseSubscritpionBlockItem>
        <TaxTotalCostTitle>
          {formatMessage(subscriptionManagementMessages.upgradePlanBottomText)}
        </TaxTotalCostTitle>
      </PurchaseSubscritpionBlockItem>
    </PurchaseSubscritpionTotalBlock>
  )
}

export default PurchaseDeviceTotal
